"use client";

import { useContext } from "react";
import { TrackErrorContext } from "./TrackErrorProvider";
export function useTrackError() {
  const {
    trackError
  } = useContext(TrackErrorContext);
  return trackError;
}